import classNames from 'classnames'
import React from 'react'

import * as styles from './text-element.module.scss'

type Props = {
  type?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' | 'p' | 'div'
  className?: string
  text?: string
  uppercase?: boolean
  border?: boolean
  [key: string]: React.ReactNode
}
const TextElement: React.FC<Props> = ({
  type,
  className = '',
  text,
  uppercase = false,
  border = false,
  children,
  ...props
}) => {
  const Element = type ?? 'h1'

  const titleClasses = classNames(className, {
    [styles.uppercasetext]: uppercase,
    [styles.bordertop]: border
  })

  return (
    <Element className={titleClasses} {...props}>
      {text ?? children}
    </Element>
  )
}

export default TextElement
